import React, { useState } from 'react';

import { Button } from '@eika/button';
import { IconTypes } from '@eika/icon';

import { CreditCardService } from '@/domain/card';

import { useNavigate } from '@domain/app';
import { Card, CreditCard } from '@generated-types';
import useText from '@hooks/use-text';

import { GoogleWalletErrorCardModal } from './GoogleWalletErrorCardModal';

interface GooglePayButtonProps {
    card: Card | CreditCard;
}

export const GooglePayButton = ({ card }: GooglePayButtonProps) => {
    const navigate = useNavigate();

    const text = useText();

    const [showModal, setShowModal] = useState<boolean>(false);

    const navigateToCard = () => {
        if (CreditCardService.isCreditCard(card)) {
            navigate('GOOGLE_WALLET')({ cid: card.id, ctype: 'CREDIT' });
        } else {
            navigate('GOOGLE_WALLET')({ cid: card.id, ctype: card.type });
        }
    };

    return (
        <>
            <Button
                className="google-pay-button"
                buttonType="negative"
                icon={IconTypes.LOMMEBOK_24}
                onClick={navigateToCard}
            >
                {text.googlePayText}
            </Button>
            <GoogleWalletErrorCardModal text={text} show={showModal} onClose={() => setShowModal(false)} />
        </>
    );
};
